import * as React from 'react';
import { AddressDTO, BuyerCustomerDTO, Res } from 'core/api';
import { FormComponent, Button, Col, Cols } from 'core/ui';
import { Binding, Result } from 'core/infrastructure';
import { Command } from 'pos/common';

type Props<T> = {
	linkTo: Binding.PropertyPath<T>;
	boundValue?: AddressDTO;
	customer: BuyerCustomerDTO;
}

type State = { currentAddress: Nullable<AddressDTO> }

export class AddressComponent<T> extends React.Component<Props<T>, State> implements FormComponent {

	constructor(props: Props<T>) {
		super(props);
		this.state = {
			currentAddress: props.boundValue || null
		};
	}

	getPath(): string {
		return Binding.propertyPathToString(this.props.linkTo);
	}

	showErrors(_errors: string[]): void {
	}

	getValue(): Result<AddressDTO> {
		return Result.ok(this.state.currentAddress || { Region: '', City: '', ZipCode: '', Street: '' });
	}

	render() {

		const onSelectAddress = async () => {
			const result = await selectDeliveryAddress(this.props.customer, this.state.currentAddress);
			if (result.ok)
				this.setState({ currentAddress: result.value });
		};

		const addressDetails = [
			this.state.currentAddress?.ZipCode ?? '',
			this.state.currentAddress?.City ?? '',
			this.state.currentAddress?.Region ? `(${this.state.currentAddress?.Region})` : ''
		].join(' ');

		return <Cols>
			<Col width='2ex' className='text-muted text-26 m-l-md'>
				<i className='fa fa-map-marker' />
			</Col>
			<Col width='*' className='p-l'>
				<p className='text-26 text-muted'>{this.state.currentAddress?.Street}</p>
				<p className='text-14 p-b-sm'>
					{addressDetails}
				</p>

				<Button buttonStyle='info' outline onClick={onSelectAddress}>
					{Res.Web.CONFIRM_DOCUMENT_DATA_CHANGE_ADDRESS_BTN()}
				</Button>
			</Col>
		</Cols>;
	}
}

export type AddressComponentCtor<T> = new (props: Props<T>) => React.Component<Props<T>, State>;

function selectDeliveryAddress(customer: BuyerCustomerDTO, currentAddress: Nullable<AddressDTO>): Promise<Result<AddressDTO>> {
	return Command.execute('changeDeliveryAddress', customer, currentAddress);
}

